import { apiSlice } from '../../app/api/apiSlice'
import { generateFormatedURL } from "../urlFormatter";

const stationApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getStationList: builder.query<any, any>({
            query: (args) => "/Station".concat(generateFormatedURL(args)),
        }),
        getAllStationList: builder.query<any, any>({
            query: (args) => "/Station/all".concat(generateFormatedURL(args)),
        }),
        getStationReportList: builder.query<any, any>({
            query: (args) => "/Station/MonthlyReport".concat(generateFormatedURL(args)),
        }),
    })
})

export const {
    useLazyGetStationListQuery,
    useLazyGetAllStationListQuery,
    useLazyGetStationReportListQuery,
} = stationApiSlice;